/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Free_NoteInputs */

const en_signin_free_note = /** @type {(inputs: Signin_Free_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free to start — no credit card required.`)
};

const id_signin_free_note = /** @type {(inputs: Signin_Free_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis untuk mulai — tanpa kartu kredit.`)
};

/**
* | output |
* | --- |
* | "Free to start — no credit card required." |
*
* @param {Signin_Free_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_free_note = /** @type {((inputs?: Signin_Free_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Free_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_free_note(inputs)
	return en_signin_free_note(inputs)
});